import { apiRequest } from "./axiosConfig";

// Add a bookmark
export const addBookmark = async (
  propertyId,
  organizerListId,
  averageGrossYield
) => {
  return apiRequest("post", "/api/bookmarks/add", {
    propertyId,
    organizerListId,
    averageGrossYield,
  });
};

// Remove a bookmark
export const removeBookmark = async (propertyId, organizerListId) => {
  return apiRequest("delete", `/api/bookmarks/delete/${propertyId}`, {
    organizerListId,
  });
};

// Update bookmark note
export const updateBookmark = async (propertyId, organizerListId, note) => {
  return apiRequest("put", "/api/bookmarks/note", {
    propertyId,
    organizerListId,
    note,
  });
};

// Fetch bookmarks for a user
export const fetchBookmarks = async (
  isPopulateProperty,
  organizerListId,
  nextUrl
) => {
  if (isPopulateProperty && !organizerListId) return;

  const url = nextUrl
    ? nextUrl
    : `/api/bookmarks?populateProperty=${isPopulateProperty}` +
      (organizerListId ? `&organizerListId=${organizerListId}` : "") +
      `&limit=10`;

  return apiRequest("get", url);
};

// Fetch save search for a user
export const fetchDashboardWeeklySummary = async () => {
  const url = `/api/bookmarks/weeklySummary`;
  return apiRequest("get", url);
};

// Fetch recently price changed property
export const fetchRecentlyPriceChangedProperty = async () => {
  const url = `/api/bookmarks/recentPriceChanged`;
  return apiRequest("get", url);
};

// Fetch last 7 days property overview
export const fetchBookmarkPropertyOverview = async (organizerListId) => {
  if (!organizerListId) return;
  const url = `/api/bookmarks/overview/${organizerListId}`;
  return apiRequest("get", url);
};
